import { render, staticRenderFns } from "./buying-prices.vue?vue&type=template&id=66501c6c&scoped=true"
import script from "./buying-prices.vue?vue&type=script&lang=js"
export * from "./buying-prices.vue?vue&type=script&lang=js"
import style0 from "./buying-prices.vue?vue&type=style&index=0&id=66501c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66501c6c",
  null
  
)

export default component.exports